module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/T-Shirt-70c951d959f330b106ba50b4a6e11187.svg";